import { html } from "lit";
var icon_lastPage_default = () => html`
  <svg stroke-fill xmlns="http://www.w3.org/2000/svg" width="11" height="14" fill="none">
    <g><path d="m1 1 6 6-6 6M10 13V1" /></g>
  </svg>
`;
export {
  icon_lastPage_default as default
};
//# sourceMappingURL=icon-lastPage.js.map
